import{BIF_PLUGIN_ID as i}from"../constants";export var isBifPlugin=function(n){var o;return(null===(o=n.getId)||void 0===o?void 0:o.call(n))===i};